import { WindhagerScheduleCard } from "./card";
import { localize } from './localize/localize';

customElements.define('windhager-schedule-card', WindhagerScheduleCard);

window.customCards = window.customCards || [];
window.customCards.push({
    type: "windhager-schedule-card",
    name: "Windhager Schedule Card",
    description: localize('common.description')
});
